import Vue from 'vue'
import toast from './toast.vue'

const bhUi = {
    Toast({text, duration = 2000, zIndex=999}) {
        const Toast = Vue.extend(toast)
        const ToastDom = new Toast({
            el: document.createElement('div'),
            data() {
                return {
                    text: text,
                    isShow: true,
                    zIndex
                }
            }
        })
        
        document.body.appendChild(ToastDom.$el)
        
        setTimeout(() => {
            document.body.removeChild(ToastDom.$el)
        }, duration)
    },
    install() {
        Vue.prototype.$bhUi = bhUi
    }
}

// const bhUi = () => {
// }

export default bhUi